import React from 'react'
import ChoiceInputField from '../ChoiceInputField'

const ChoiceFieldCaption: React.FC = ({children}) => <ChoiceInputField.Caption>{children}</ChoiceInputField.Caption>

export default ChoiceFieldCaption
